export class ConnectionPermissionsGroupDetailService {
  static $inject = ['GroupMembershipModel'];

  constructor(private GroupMembershipModel) {}

  getGroupMemberships(userGroup): Promise<any[]> {
    return userGroup
      .groupMemberships({
        includes: { group_memberships: 'member' },
      })
      .then((response) => response.elements());
  }

  getGroupMembers(userGroup): Promise<any> {
    return this.getGroupMemberships(userGroup).then((groupMemberships) =>
      this.GroupMembershipModel.buildMembershipsWithAccount(groupMemberships).then((builtMemberships) =>
        builtMemberships.map((member) => member._resource.embedded('member'))
      )
    );
  }

  getGroupMembersList(userGroup): Promise<any> {
    return this.getGroupMembers(userGroup).then((groupMembers) =>
      groupMembers.map((groupMember) => {
        const member = groupMember;
        member.avatar = {
          avatar: groupMember.avatar,
          size: 30,
        };
        return member;
      })
    );
  }
}
